import React, { useRef, useState } from "react"
import { List, VStack } from "@chakra-ui/react"
import _ from "lodash"
import { GuestSummary } from "sharedTypes"
import GuestList from "components/GuestList/GuestList"
import {
  GuestRow, GuestRowBody, GuestRowPerson, GuestRowSeat,
} from "components/GuestList/GuestRow"
import ListHeader from "../pages/EventShow/Guests/ScrollView/GuestListHeader"
import Modal from "../components/dialogs/Modal"
import { useGuests } from "../queries/guests"

type Props = {
  eventId: string
  onSelect: (guest: GuestSummary) => void
  onClose: () => void
  filtered: boolean
  showMenu?: boolean
  disabledGuestIds?: string[]
  disableMainGuests?: boolean
  showTables?: boolean
}

const SelectGuest = ({
  eventId,
  onSelect,
  onClose,
  filtered,
  showMenu = true,
  disabledGuestIds = [],
  disableMainGuests,
  showTables = true,
}: Props) => {
  const scrollRef = useRef<HTMLUListElement>(null)
  const [searchString, setSearchString] = useState("")
  const [guestsOrder, setGuestsOrder] = useState("first_name_asc")

  const { guests, fetchNextPage, isLoading } = useGuests(eventId, searchString, guestsOrder)

  const handleScroll = (e) => {
    if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight) {
      fetchNextPage()
    }
  }
  const debouncedHandleScroll = _.debounce(handleScroll, 100)

  return (
    <Modal
      title="Select Guest"
      show
      size="md"
      h="80%"
      noPadding
      hide={onClose}
    >
      <VStack h="full">
        <ListHeader
          loading={isLoading}
          searchString={searchString}
          onSearch={(query) => setSearchString(query)}
          order={guestsOrder}
          onSetOrder={(value) => setGuestsOrder(value)}
          showMenu={showMenu}
          clearSelectedGuestOnSearch={false}
        />
        <List
          ref={scrollRef}
          w="full"
          h={72}
          flexGrow={1}
          overflowY="scroll"
          onScroll={(e) => {
            e.persist()
            debouncedHandleScroll(e)
          }}
        >
          <GuestList guests={guests} filtered={filtered} scrollRef={scrollRef}>
            {(guest, plusOne) => {
              const disabled = (disableMainGuests && !!guest.plusOnes?.length)
                || disabledGuestIds.includes(guest.id)
              const seat = showTables ? guest.seatingAssignment : null

              return (
                <GuestRow seated={!!seat}>
                  <GuestRowBody
                    plusOne={plusOne}
                    disabled={disabled}
                    cursor={disabled ? undefined : "pointer"}
                    onClick={disabled ? undefined : () => {
                      onSelect(guest)
                      onClose()
                    }}
                  >
                    <GuestRowPerson guest={guest} order={guestsOrder} />
                  </GuestRowBody>
                  {seat && <GuestRowSeat {...seat} />}
                </GuestRow>
              )
            }}
          </GuestList>
        </List>
      </VStack>
    </Modal>
  )
}

export default SelectGuest
